import Loadable from '@loadable/component';
import React, { useRef } from 'react';
import { connect, ConnectedProps } from 'react-redux';

import { RootState } from './reducers';

import LoadingIndicator from 'Components/loading/LoadingBars';

const LoadableMain = Loadable(() => import('Containers/Main'), {
  fallback: <LoadingIndicator />,
});

const mapState = ({ nav: { location }, user }: RootState) => {
  return {
    path: location,
    user: user,
  };
};

const connector = connect(mapState);

type Props = ConnectedProps<typeof connector> & {
  /* prop types here */
};

const App: React.FC<React.PropsWithChildren<Props>> = () => {
  // this ref is anticipating a world where we want to use the header/banner logic from lv-web
  const headerRef = useRef<HTMLDivElement>(null);

  return (
    <>
      <div id="header-container" ref={headerRef} />
      <LoadableMain />
    </>
  );
};

export default connector(App);
